import { render, staticRenderFns } from "./SkillsEdit.vue?vue&type=template&id=236f69d0&scoped=true"
import script from "./SkillsEdit.vue?vue&type=script&lang=js"
export * from "./SkillsEdit.vue?vue&type=script&lang=js"
import style0 from "./SkillsEdit.vue?vue&type=style&index=0&id=236f69d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f69d0",
  null
  
)

export default component.exports